













































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { routerModule } from '@/store';
import { Terms } from '@/api';

/**
 * The T&Cs reader.
 *
 * It owns no acceptance of its own. The footer is an `actions` slot, defaulting
 * to a bare Close button: registration opens it as a pure reader and accepts
 * via its own checkbox, while the alert box for existing users fills the slot
 * with "I agree", so acceptance sits at the bottom of the text the user just
 * read. The close icon in the title bar is always there either way. See
 * FRONTEND-LOG.md items 5 and 14 in dj-gowans.
 *
 * The text is not Django's to serve: Django returns only a `sourceUrl` pointing
 * at the WordPress page, and the body is fetched from WordPress.
 */
@Component
export default class TermsDialog extends Vue {
  @Prop({ default: false }) value: boolean;

  loading: boolean = false;

  loaded: boolean = false;

  error: string = '';

  content: string = '';

  sourceUrl: string = '';

  get open() {
    return this.value;
  }

  set open(v: boolean) {
    this.$emit('input', v);
  }

  /** Exposed to the `actions` slot so a filled-in footer can still close. */
  close() {
    this.open = false;
  }

  @Watch('value')
  onOpen(opened: boolean) {
    // Fetch on first open rather than on mount: this component is mounted
    // alongside forms that most visitors never open the terms from.
    if (opened && !this.loaded && !this.loading) {
      this.load();
    }
  }

  async load() {
    this.loading = true;
    this.error = '';
    try {
      const terms = await Terms.current();
      if (!terms || !terms.sourceUrl) {
        throw new Error('no source url');
      }
      this.sourceUrl = terms.sourceUrl;
      const page = await routerModule.getPage(this.path(terms.sourceUrl));
      this.content = page.content.rendered;
      this.loaded = true;
    } catch (e) {
      this.error = 'The terms and conditions could not be loaded just now.';
    } finally {
      this.loading = false;
    }
  }

  /**
   * WordPress is asked for a path, not an absolute URL. Falling back to the
   * raw value keeps a relative `sourceUrl` working too.
   */
  path(sourceUrl: string): string {
    try {
      return new URL(sourceUrl).pathname;
    } catch {
      return sourceUrl;
    }
  }
}
